import { Link } from "react-router-dom";
import { categories } from "@/mocks/hotNews";

const tileTone = [
  "from-primary-500 to-secondary-500",
  "from-accent-500 to-primary-400",
  "from-secondary-500 to-primary-400",
  "from-primary-600 to-accent-500",
  "from-accent-600 to-secondary-500",
];

export default function HomeCategories() {
  return (
    <section className="container-x py-10 md:py-14">
      <div className="mb-6 flex items-end justify-between gap-4">
        <div>
          <span className="chip bg-secondary-100 text-secondary-900 px-3 py-1 text-xs font-bold">
            <i className="ri-focus-3-line"></i> 内容频道
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-3xl">按你关心的领域开吃</h2>
        </div>
        <Link to="/news" className="hidden shrink-0 text-sm font-medium text-primary-600 hover:text-primary-700 sm:inline-flex">
          全部资讯 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 gap-3 md:grid-cols-5 md:gap-4">
        {categories.map((c, i) => (
          <Link
            key={c.id}
            to={`/news?category=${c.id}`}
            className={`group relative overflow-hidden rounded-2xl bg-gradient-to-br ${tileTone[i]} p-5 text-background-50 transition-transform duration-300 hover:-translate-y-1`}
          >
            <div className="absolute -right-4 -top-4 h-16 w-16 rounded-full bg-background-50/15 transition-transform group-hover:scale-125"></div>
            <i className={`${c.icon} relative text-2xl`}></i>
            <h3 className="relative mt-5 font-heading text-lg leading-none">{c.name}</h3>
            <p className="relative mt-2 text-xs text-background-100/85">{c.desc}</p>
            <span className="relative mt-3 inline-flex items-center gap-1 text-xs text-background-100/90">
              进频道 <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}